import { CommonError } from '@common/models/error.model';
import { BaseRawHttpResponse } from '@common/models/response.model';
import { isObjectTypeValid } from '@util/utils/object.util';

/**
 * Throw error if the response gotten is indeed an error
 *
 * @param response
 * @returns
 */
export function getErrorFromHttpRawResponse(response: unknown): CommonError | undefined {
  // Check response according to API spec
  let isValid = isObjectTypeValid<BaseRawHttpResponse>(
    response,
    ['message', 'status_code'],
    'every',
  );
  // Check response according to Azure error
  isValid ||= isObjectTypeValid<BaseRawHttpResponse>(response, ['message', 'statusCode'], 'every');

  if (!isValid) return undefined;

  const httpResponse = response as Partial<BaseRawHttpResponse>;
  const httpResponseStatusCode =
    // Check from API status
    httpResponse.status_code ??
    // Check from Azure status
    httpResponse.statusCode;
  // Parse the status code
  const httpResponseStatusCodeNumber =
    typeof httpResponseStatusCode === 'string'
      ? parseFloat(httpResponseStatusCode)
      : httpResponseStatusCode;

  if (
    httpResponseStatusCodeNumber != null &&
    httpResponseStatusCodeNumber >= 200 &&
    httpResponseStatusCodeNumber < 300
  ) {
    return undefined;
  }

  return new CommonError({
    code: '',
    message: httpResponse.message ?? '',
    statusCode: httpResponseStatusCodeNumber,
  });
}

export default {};
